import { render, staticRenderFns } from "./errormessage.vue?vue&type=template&id=f937830a&"
import script from "./errormessage.vue?vue&type=script&lang=js&"
export * from "./errormessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports